<template>
  <div>
    <div class="d-flex align-items-start justify-content-between">
      <div class="w_100 pb-5 bg-white">

        <div class="row mx-0">
          <div class="col-md-12 home-content mt-2 px-4 pb-5">
            <div class="loader absolute mt-3" v-if="loader"></div>
            <template v-else>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col">Rang</th>
                  <th scope="col">Nom de l'etudiant</th>
                  <th scope="col">Nombre de points</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="(account, indextr) in users" :key="indextr">
                    <th scope="row border-right border-gray">
                      {{account.id}}
                    </th>
                    <td>
                      {{account.full_name}}
                    </td>
                    <td>
                      {{account.points}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  components: {
  },
  props: {
    backRoute: {type: [String, Object, null], default: null}
  },
  filters: {
    ago: function (data) {
      return moment(data).fromNow();
    }
  },
  data() {
    return {
      loader: false,
    }
  },
  methods: {
    loadData() {
      this.loader = true;
      this.$store.dispatch('account/getUsers').finally((data) => {
        this.loader = false;
      });
    },
  },
  computed: {
    ...mapGetters({
      'users': 'account/users',
      'user': 'user',
    }),
  },
  watch: {
    date(val) {
      this.loadData()
    },
    menuItem(val) {
      this.loadData()
    }
  },
  created() {
    this.loadData();
    this.$route.meta.backToRoute = this.backRoute ? this.backRoute : this.$router.resolve({name: 'home'});
    this.$route.meta.other_header_menu = true;
  }
}
</script>

